export class Fuel {
    id              : number;
    fleet_id        : number; 
    driver_id       : number;
    provider_id     : number;
    fuel_card_id    : number;
    fuel_type       : string;
    hours           : string;
    fault           : string;
    cost            : number;
    litres          : number;
    date            : string;
    time            : string;
    odometer        : number;
    receipt_no      : string;
    note            : string;
    file            : string;
    file1            : string;
    docket_file     : string;
    lat             : number;
    lng             : number;
    location        : string;
    fuel_items      : FuelItem[];
    manifest_id     : number;
    job_id          : number;

    ////
    company_name    : string;
    rego            : string;
    card_no         : string;
    customer        : string;
    control_no      : string;
    driver_name     : string;
    user_id         : number;
    map             : string;
    hasFile         : string;
    fileCount       : number;
    time_string     : TimeString;

}

export class FuelItem {
    id				    : number;
    fuel_id             : number;
    fuel_type_id        : number;
    rate_id				: number;
    quantity			: number;
    total				: number;
    created_at          : string;
    updated_at          : string;
    
    ////
    name                : string;
    rate    			: number;
    gst		        	: number;
    rate_dollar         : number;
    rate_gst            : string;
}

export class FuelRate{
    id              : number;
    fuel_type_id    : number;
    provider_id     : number;
    rate            : number;
    gst             : number;
    
}


export interface TimeString {
    hour: number;
    minute: number;
}
